import { render, staticRenderFns } from "./groupSender.vue?vue&type=template&id=0aeb8c5a&"
import script from "./groupSender.vue?vue&type=script&lang=js&"
export * from "./groupSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports